export const colorFamilies = [
  // --- MULTICOLOR OPTION (Top Priority) ---
  { name: 'Multicolor', hex: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)' },

  // --- ORIGINAL COLORS (Apke diye gaye colors) ---
  { name: 'Red', hex: '#EF4444' },
  { name: 'Blue', hex: '#3B82F6' },
  { name: 'Green', hex: '#10B981' },
  { name: 'Yellow', hex: '#FBBF24' },
  { name: 'Black', hex: '#111827' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Pink', hex: '#EC4899' },
  { name: 'Orange', hex: '#F97316' },
  { name: 'Purple', hex: '#8B5CF6' },
  { name: 'Brown', hex: '#78350F' },
  { name: 'Grey', hex: '#6B7280' },
  { name: 'Silver', hex: '#D1D5DB' },
  { name: 'Gold', hex: '#F59E0B' },
  { name: 'Beige', hex: '#F5F5DC' },
  { name: 'Olive', hex: '#556B2F' },
  { name: 'Maroon', hex: '#800000' },
  { name: 'Navy Blue', hex: '#1E3A8A' },
  { name: 'Teal', hex: '#0D9488' },
  { name: 'Turquoise', hex: '#06B6D4' },
  { name: 'Cream', hex: '#FFFDD0' },
  { name: 'Peach', hex: '#FFDAB9' },
  { name: 'Mustard', hex: '#EAB308' },
  { name: 'Rust', hex: '#B45309' },
  { name: 'Mint Green', hex: '#A7F3D0' },
  { name: 'Plum', hex: '#DDA0DD' },
  { name: 'Coral', hex: '#F87171' },
  { name: 'Lavender', hex: '#E9D5FF' },
  { name: 'Charcoal', hex: '#374151' },
  { name: 'Indigo', hex: '#4F46E5' },
  { name: 'Ivory', hex: '#FFFFF0' },
  { name: 'Khaki', hex: '#F0E68C' },
  { name: 'Magenta', hex: '#D946EF' },
  { name: 'Tan', hex: '#D2B48C' },
  { name: 'Emerald', hex: '#047857' },
  { name: 'Cyan', hex: '#22D3EE' },
  { name: 'Champagne', hex: '#F3E5AB' },
  { name: 'Bronze', hex: '#CD7F32' },
  { name: 'Apricot', hex: '#FB923C' },
  { name: 'Amber', hex: '#D97706' },

  // --- NEW ADDITIONS: REDS & PINKS ---
  { name: 'Crimson', hex: '#DC143C' },
  { name: 'Dark Red', hex: '#8B0000' },
  { name: 'Firebrick', hex: '#B22222' },
  { name: 'Indian Red', hex: '#CD5C5C' },
  { name: 'Light Coral', hex: '#F08080' },
  { name: 'Salmon', hex: '#FA8072' },
  { name: 'Dark Salmon', hex: '#E9967A' },
  { name: 'Light Salmon', hex: '#FFA07A' },
  { name: 'Deep Pink', hex: '#FF1493' },
  { name: 'Hot Pink', hex: '#FF69B4' },
  { name: 'Pale Violet Red', hex: '#DB7093' },
  { name: 'Medium Violet Red', hex: '#C71585' },
  { name: 'Ruby', hex: '#E0115F' },
  { name: 'Cherry', hex: '#D2042D' },
  { name: 'Rose', hex: '#FF007F' },
  { name: 'Blood Red', hex: '#660000' },
  { name: 'Carmine', hex: '#960018' },
  { name: 'Cerise', hex: '#DE3163' },
  { name: 'Mahogany', hex: '#C04000' },
  { name: 'Watermelon', hex: '#FC6C85' },
  { name: 'Raspberry', hex: '#E30B5D' },
  { name: 'Fuchsia', hex: '#FF00FF' },

  // --- NEW ADDITIONS: ORANGES & YELLOWS ---
  { name: 'Tomato', hex: '#FF6347' },
  { name: 'Orange Red', hex: '#FF4500' },
  { name: 'Dark Orange', hex: '#FF8C00' },
  { name: 'Light Yellow', hex: '#FFFFE0' },
  { name: 'Lemon Chiffon', hex: '#FFFACD' },
  { name: 'Light Goldenrod', hex: '#FAFAD2' },
  { name: 'Papaya Whip', hex: '#FFEFD5' },
  { name: 'Moccasin', hex: '#FFE4B5' },
  { name: 'Peach Puff', hex: '#FFDAB9' },
  { name: 'Pale Goldenrod', hex: '#EEE8AA' },
  { name: 'Dark Khaki', hex: '#BDB76B' },
  { name: 'Sunset Orange', hex: '#FD5E53' },
  { name: 'Honey', hex: '#FFC30B' },
  { name: 'Saffron', hex: '#F4C430' },
  { name: 'Citrine', hex: '#E4D00A' },
  { name: 'Buttercup', hex: '#F3E5AB' },
  { name: 'Tangerine', hex: '#F28500' },
  { name: 'Pumpkin', hex: '#FF7518' },
  { name: 'Neon Yellow', hex: '#FFFF33' },
  { name: 'Golden Yellow', hex: '#FFDF00' },

  // --- NEW ADDITIONS: GREENS ---
  { name: 'Green Yellow', hex: '#ADFF2F' },
  { name: 'Chartreuse', hex: '#7FFF00' },
  { name: 'Lawn Green', hex: '#7CFC00' },
  { name: 'Lime', hex: '#00FF00' },
  { name: 'Lime Green', hex: '#32CD32' },
  { name: 'Pale Green', hex: '#98FB98' },
  { name: 'Light Green', hex: '#90EE90' },
  { name: 'Medium Spring Green', hex: '#00FA9A' },
  { name: 'Spring Green', hex: '#00FF7F' },
  { name: 'Medium Sea Green', hex: '#3CB371' },
  { name: 'Sea Green', hex: '#2E8B57' },
  { name: 'Forest Green', hex: '#228B22' },
  { name: 'Dark Green', hex: '#006400' },
  { name: 'Yellow Green', hex: '#9ACD32' },
  { name: 'Olive Drab', hex: '#6B8E23' },
  { name: 'Dark Olive Green', hex: '#556B2F' },
  { name: 'Medium Aquamarine', hex: '#66CDAA' },
  { name: 'Dark Sea Green', hex: '#8FBC8F' },
  { name: 'Light Sea Green', hex: '#20B2AA' },
  { name: 'Dark Cyan', hex: '#008B8B' },
  { name: 'Jade', hex: '#00A86B' },
  { name: 'Fern', hex: '#4F7942' },
  { name: 'Moss', hex: '#8A9A5B' },
  { name: 'Shamrock', hex: '#009E60' },
  { name: 'Pine', hex: '#01796F' },
  { name: 'Seafoam', hex: '#9FE2BF' },
  { name: 'Neon Green', hex: '#39FF14' },
  { name: 'Army Green', hex: '#4B5320' },
  { name: 'Kelly Green', hex: '#4CBB17' },

  // --- NEW ADDITIONS: BLUES & CYANS ---
  { name: 'Aqua', hex: '#00FFFF' },
  { name: 'Light Cyan', hex: '#E0FFFF' },
  { name: 'Pale Turquoise', hex: '#AFEEEE' },
  { name: 'Aquamarine', hex: '#7FFFD4' },
  { name: 'Medium Turquoise', hex: '#48D1CC' },
  { name: 'Dark Turquoise', hex: '#00CED1' },
  { name: 'Cadet Blue', hex: '#5F9EA0' },
  { name: 'Steel Blue', hex: '#4682B4' },
  { name: 'Light Steel Blue', hex: '#B0C4DE' },
  { name: 'Powder Blue', hex: '#B0E0E6' },
  { name: 'Light Blue', hex: '#ADD8E6' },
  { name: 'Sky Blue', hex: '#87CEEB' },
  { name: 'Light Sky Blue', hex: '#87CEFA' },
  { name: 'Deep Sky Blue', hex: '#00BFFF' },
  { name: 'Dodger Blue', hex: '#1E90FF' },
  { name: 'Cornflower Blue', hex: '#6495ED' },
  { name: 'Royal Blue', hex: '#4169E1' },
  { name: 'Medium Blue', hex: '#0000CD' },
  { name: 'Dark Blue', hex: '#00008B' },
  { name: 'Midnight Blue', hex: '#191970' },
  { name: 'Cobalt', hex: '#0047AB' },
  { name: 'Denim', hex: '#1560BD' },
  { name: 'Azure', hex: '#F0FFFF' },
  { name: 'Sapphire', hex: '#0F52BA' },
  { name: 'Cerulean', hex: '#007BA7' },
  { name: 'Lapis Lazuli', hex: '#26619C' },
  { name: 'Baby Blue', hex: '#89CFF0' },
  { name: 'Prussian Blue', hex: '#003153' },
  { name: 'Neon Blue', hex: '#04D9FF' },

  // --- NEW ADDITIONS: PURPLES & VIOLETS ---
  { name: 'Thistle', hex: '#D8BFD8' },
  { name: 'Violet', hex: '#EE82EE' },
  { name: 'Orchid', hex: '#DA70D6' },
  { name: 'Medium Orchid', hex: '#BA55D3' },
  { name: 'Medium Purple', hex: '#9370DB' },
  { name: 'Blue Violet', hex: '#8A2BE2' },
  { name: 'Dark Violet', hex: '#9400D3' },
  { name: 'Dark Orchid', hex: '#9932CC' },
  { name: 'Dark Magenta', hex: '#8B008B' },
  { name: 'Dark Slate Blue', hex: '#483D8B' },
  { name: 'Slate Blue', hex: '#6A5ACD' },
  { name: 'Medium Slate Blue', hex: '#7B68EE' },
  { name: 'Amethyst', hex: '#9966CC' },
  { name: 'Grape', hex: '#6F2DA8' },
  { name: 'Mauve', hex: '#E0B0FF' },
  { name: 'Mulberry', hex: '#C54B8C' },
  { name: 'Lilac', hex: '#C8A2C8' },
  { name: 'Periwinkle', hex: '#CCCCFF' },
  { name: 'Eggplant', hex: '#614051' },
  { name: 'Boysenberry', hex: '#873260' },

  // --- NEW ADDITIONS: BROWNS & NEUTRALS ---
  { name: 'Cornsilk', hex: '#FFF8DC' },
  { name: 'Blanched Almond', hex: '#FFEBCD' },
  { name: 'Bisque', hex: '#FFE4C4' },
  { name: 'Navajo White', hex: '#FFDEAD' },
  { name: 'Wheat', hex: '#F5DEB3' },
  { name: 'Burlywood', hex: '#DEB887' },
  { name: 'Rosy Brown', hex: '#BC8F8F' },
  { name: 'Sandy Brown', hex: '#F4A460' },
  { name: 'Goldenrod', hex: '#DAA520' },
  { name: 'Dark Goldenrod', hex: '#B8860B' },
  { name: 'Peru', hex: '#CD853F' },
  { name: 'Chocolate', hex: '#D2691E' },
  { name: 'Saddle Brown', hex: '#8B4513' },
  { name: 'Sienna', hex: '#A0522D' },
  { name: 'Coffee', hex: '#6F4E37' },
  { name: 'Mocha', hex: '#4E312D' },
  { name: 'Peanut', hex: '#795C34' },
  { name: 'Caramel', hex: '#FFD59A' },
  { name: 'Sepia', hex: '#704214' },
  { name: 'Chestnut', hex: '#954535' },
  { name: 'Taupe', hex: '#483C32' },
  { name: 'Sand', hex: '#C2B280' },
  { name: 'Walnut', hex: '#773F1A' },

  // --- NEW ADDITIONS: GREYS, WHITES & BLACKS ---
  { name: 'Snow', hex: '#FFFAFA' },
  { name: 'Honeydew', hex: '#F0FFF0' },
  { name: 'Mint Cream', hex: '#F5FFFA' },
  { name: 'Alice Blue', hex: '#F0F8FF' },
  { name: 'Ghost White', hex: '#F8F8FF' },
  { name: 'White Smoke', hex: '#F5F5F5' },
  { name: 'Seashell', hex: '#FFF5EE' },
  { name: 'Old Lace', hex: '#FDF5E6' },
  { name: 'Floral White', hex: '#FFFAF0' },
  { name: 'Antique White', hex: '#FAEBD7' },
  { name: 'Linen', hex: '#FAF0E6' },
  { name: 'Lavender Blush', hex: '#FFF0F5' },
  { name: 'Misty Rose', hex: '#FFE4E1' },
  { name: 'Gainsboro', hex: '#DCDCDC' },
  { name: 'Light Gray', hex: '#D3D3D3' },
  { name: 'Dark Gray', hex: '#A9A9A9' },
  { name: 'Dim Gray', hex: '#696969' },
  { name: 'Light Slate Gray', hex: '#778899' },
  { name: 'Dark Slate Gray', hex: '#2F4F4F' },
  { name: 'Jet', hex: '#343434' },
  { name: 'Onyx', hex: '#353839' },
  { name: 'Coal', hex: '#0C090A' },
  { name: 'Ebony', hex: '#555D50' },
  { name: 'Slate', hex: '#708090' },
  { name: 'Ash', hex: '#B2BEB5' },
  { name: 'Graphite', hex: '#383838' },
  { name: 'Platinum', hex: '#E5E4E2' },
  { name: 'Zinc', hex: '#71717A' }
];